export default class OffenseSearch {
  constructor(public requestNbr: number,
    public caseNbr: number,
    public refName: string,
    public refAddr1: string,
    public refCity: string,
    public refState: string,
    public refZip: string,
    public workState: string,
    public restrictedState: string,
    public  dob: Date,
    public jurisdiction: string,
    public jurisdictionId: number,
    public ssn: string,
    public searchFromDt: string,
    public searchToDt: string,
    public admittedCrimNotFound: boolean,
    public status: string,
    public sourceName: string,
    public sourceType: string,
    public licenseNumber: string,
    public isHeightenedIdentifier: Boolean) {}

    get requestNumber(): number {
      return this.requestNbr;
    }

    get caseNumber(): number {
      return this.caseNbr;
    }

    get fullName(): string {
      return this.refName;
    }

    get address1(): string {
      return this.refAddr1;
    }

    get city(): string {
      return this.refCity;
    }

    get state(): string {
      return this.refState;
    }

    get zip(): string {
      return this.refZip;
    }

    get isRestrictedState(): boolean {
      return this.restrictedState === 'Y';
    }

    get socialSecurityNumber(): string {
      return this.ssn === null || this.ssn === undefined || this.ssn.length !== 9
        ? this.ssn
        : `${this.ssn.slice(0, 3)}-${this.ssn.slice(3, 5)}-${this.ssn.slice(5)}`;
    }

    get searchFromDate(): string {
      return this.searchFromDt;
    }

    get searchToDate(): string {
      return this.searchToDt;
    }

    static createFromRequest(offenseSearch: any): OffenseSearch {
      return offenseSearch == null
        ? null
        : new OffenseSearch(offenseSearch.requestNbr,
          offenseSearch.caseNbr,
          offenseSearch.refName,
          offenseSearch.refAddr1,
          offenseSearch.refCity,
          offenseSearch.refState,
          offenseSearch.refZip,
          offenseSearch.workState,
          offenseSearch.restrictedState,
          new Date(offenseSearch.dob),
          offenseSearch.jurisdiction,
          offenseSearch.jurisdictionId,
          offenseSearch.ssn,
          offenseSearch.searchFromDt,
          offenseSearch.searchToDt,
          offenseSearch.admittedCrimNotFound,
          offenseSearch.status,
          offenseSearch.sourceName,
          offenseSearch.sourceType,
          offenseSearch.licenseNumber,
          offenseSearch.isHeightenedIdentifier);
    }

}



// WEBPACK FOOTER //
// ./src/models/offenseSearch.ts